import { shallowMount } from "@vue/test-utils";
import Confirmar from "@/views/Confirmar";

describe("Confirmar component", () => {
  let wrapper;

  beforeEach(() => {
    wrapper = shallowMount(Confirmar);
  });

  it("Renders del component Confirmar", () => {
    expect(wrapper).toBeDefined();
  });
});
